/* eslint-disable @typescript-eslint/no-explicit-any */
import { CommMessage, Effect, TMCoreAction } from 'state/service/appTs/types';
import { ElmWalkInPartyDescription } from 'types/service';
import { Floorplan, OutboundAction } from './types';
import { ServiceParseError } from 'state/service/appTs/serviceErrors';
import { ServiceStateAppStrict } from 'state/service/app';
import { assertNever } from '@tock/shared/utils/typeUtils';
import { tocktix as dashboardProto } from '@tock/protos/dist/types/dashboard';
import { tocktix as ssmProto } from '@tock/protos/dist/types/ssm';
import _ from 'lodash';

export function encodeFloorplan(floorplan: Floorplan): ServiceStateAppStrict['floorplan'] {
  const { id, tables, tableCombinations } = floorplan;
  const tablesArray = _.compact(Object.values(tables));
  return {
    id,
    activeTable: tablesArray.filter((t) => !t.isArchived),
    archivedTable: tablesArray.filter((t) => t.isArchived),
    tableCombination: tableCombinations,
  };
}

function encodeActionPb(action: TMCoreAction): ssmProto.lib.IMessageSet {
  switch (action.type) {
    case 'UpdateTableState':
      return {
        '.tocktix.proto.dashboard.UpdateTableState.messageSetExtension': {
          tableId: action.tableAndState.tableId,
          newState: action.tableAndState.newState,
        },
      };
    case 'AddWalkInParty':
      return {
        '.tocktix.proto.dashboard.AddWalkInPartyAction.messageSetExtension': {
          description: encodeWalkInPartyDescription(action.partyDescription),
        },
      };
    default:
      return undefined as any; // TODO
    // return assertNever(action);
  }
}

function encodeWalkInPartyDescription(
  partyDescription: ElmWalkInPartyDescription
): dashboardProto.proto.dashboard.IWalkInPartyDescription {
  return { ...partyDescription, shortNotes: partyDescription.shortNotes || undefined };
}

function encodeWebsocketCommMessage(websocketCommMessage: CommMessage): ssmProto.lib.IMessageSet {
  switch (websocketCommMessage.type) {
    case 'Core':
      return encodeActionPb(websocketCommMessage.action);
    case 'Chat':
      return encodeChatMessagePb();
    case 'ClientConnect':
      throw new ServiceParseError('Client cannot originate ClientConnect messages'); // TODO;
    case 'Batch':
      return encodeBatchPb();
    default:
      return assertNever(websocketCommMessage);
  }
}

function encodeChatMessagePb(): ssmProto.lib.IMessageSet {
  return null as any; // TODO
}

function encodeBatchPb(): ssmProto.lib.IMessageSet {
  return null as any; // TODO
}

export function encodeOutboundAction(effect: Effect): OutboundAction {
  return { ...effect, action: encodeWebsocketCommMessage(effect.action) };
}
